import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import SectionTitle from "@/components/base/SectionTitle";

export default function Links() {
  const links = [
    {
      name: "日本試験機工業会",
      url: "http://www.jtma.jp/",
      desc: "Japan Testing Machinery Association - 加盟しています",
      icon: "ri-building-2-line",
    },
    {
      name: "東京科学機器協会",
      url: "http://www.sia-tokyo.gr.jp/",
      desc: "SIA TOKYO - 加盟しています",
      icon: "ri-microscope-line",
    },
    {
      name: "一般財団法人 日本規格協会",
      url: "https://www.jsa.or.jp/jsa/",
      desc: "JSA - 加盟しています",
      icon: "ri-file-list-3-line",
    },
  ];

  return (
    <PageLayout>
      <div className="relative py-14 md:py-20 bg-primary-700 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/80436b53-2f44-4418-8a54-006b498fe6db_compressed_IMG_5559.webp"
            alt="日本試験機工業会"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Breadcrumb */}
            <nav className="mb-4">
              <ol className="flex items-center gap-2 text-sm text-background-300">
                <li>
                  <Link to="/" className="hover:text-background-100 transition-colors">
                    ホーム
                  </Link>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line text-xs" />
                </li>
                <li className="text-background-100">リンク</li>
              </ol>
            </nav>
            <h1 className="text-3xl md:text-4xl font-black text-background-50">リンク</h1>
            <p className="text-accent-300 text-sm mt-2">related links</p>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <SectionTitle
            title="関連リンク"
            subtitle="ファクトケイが加盟する業界団体・関連組織へのリンクです"
            centered
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
            {links.map((l, i) => (
              <a
                key={i}
                href={l.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${l.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-700 transition-colors">
                  {l.name}
                </h3>
                <p className="text-sm text-foreground-500">{l.desc}</p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-600">
                  <span>サイトを見る</span>
                  <i className="ri-external-link-line"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}